import React from 'react'
import styled from 'styled-components'
import Box from './Box'

interface AspectRatioBoxProps {
  $width: number
  $height: number
}

const calculateAspectRatio = (width: number, height: number): string =>
  `${((height / width) * 100).toFixed(2)}%`

const AspectRatioBox = styled(Box).attrs<
  AspectRatioBoxProps & React.ComponentPropsWithRef<typeof Box>
>(({$styles = {}, $width, $height}) => ({
  $styles: {
    position: 'relative',
    height: 0,
    overflow: 'hidden',
    paddingTop: calculateAspectRatio($width, $height),
    ...$styles,
  },
}))<AspectRatioBoxProps & React.ComponentPropsWithRef<typeof Box>>``

export default AspectRatioBox
